// extracted by mini-css-extract-plugin
module.exports = {"page":"_12817","rule":"_7083","container":"_14421","title":"_15037","content":"_7838"};